import { useTranslation } from "react-i18next";
import { ReactComponent as UsersOutlined } from "assets/icons/menu/usersOutlined.svg";
import { ReactComponent as VideoUploadBackground } from "assets/icons/videoUploadBackground.svg";
import RetailFormRow from "components/Form/RetailFormRow";
import RetailFormInfo from "components/Form/RetailFormInfo";
import RetailMainButton from "components/Button/RetailMainButton";
import RetailText from "components/Typography/RetailText";
import RetailTitle from "components/Typography/RetailTitle";
import cc from "classcat";
import cm from "./style.module.scss";

const OffsiteAudience = ({
  setAudienceDrawerVisible,
}: {
  setAudienceDrawerVisible: (visible: boolean) => void;
}) => {
  const { t } = useTranslation();
  return (
    <RetailFormRow className={cc(["form-row", cm.audienceRow])}>
      <RetailFormInfo
        column={{
          number: "4",
          title: t("components.offsiteCampaignForm.firstStep.audience"),
          text: t("components.offsiteCampaignForm.firstStep.audienceText"),
        }}
      />
      <div className={cm.audienceContainer}>
        <div className={cm.audienceSectionContainer}>
          <VideoUploadBackground className={cm.audienceBackgroundIcon} />
          <UsersOutlined className={cm.audienceIcon} />
          <RetailTitle level={5} className={cm.audienceTitle}>
            {t("components.offsiteCampaignForm.firstStep.setAudience")}
          </RetailTitle>
          <RetailText size="xxs" weight="medium" className={cm.audienceText}>
            {t("components.offsiteCampaignForm.firstStep.defineAudience")}
          </RetailText>
          <div className={cm.audienceBtnContainer}>
            <RetailMainButton
              isPrimaryBorder={true}
              onClick={() => setAudienceDrawerVisible(true)}
              className={cm.audienceButton}
            >
              {t("components.offsiteCampaignForm.firstStep.set")}
            </RetailMainButton>
          </div>
        </div>
      </div>
    </RetailFormRow>
  );
};

export default OffsiteAudience;
